import { render } from "./ParamsItem.vue?vue&type=template&id=10569e9a"
import script from "./ParamsItem.vue?vue&type=script&lang=js"
export * from "./ParamsItem.vue?vue&type=script&lang=js"

import "./ParamsItem.vue?vue&type=style&index=0&id=10569e9a&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__